export default function Logo({ height = 44, variant = "dark", className = "" }) {
  // "dark" = rendered on a DARK background (sidebar, footer) → invert to appear white/legible
  // "light" = rendered on a LIGHT background → show original coloured logo
  const isDarkBg = variant === "dark";
  return (
    <div
      className={`inline-flex items-center ${className}`}
      data-testid="brothers-logo"
      style={{ height }}
    >
      <img
        src="/brothers-logo.png"
        alt="Brothers Advertising"
        style={{
          height,
          width: "auto",
          maxWidth: height * 5,
          objectFit: "contain",
          // On dark backgrounds we render the brand mark in solid white so both
          // words stay legible without any coloured backdrop.
          filter: isDarkBg ? "brightness(0) invert(1)" : "none",
        }}
      />
    </div>
  );
}
